document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion_trigger > button").forEach((button) => {
    button.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isActive = this.classList.contains("active");

      // Close all other accordions
      document.querySelectorAll(".accordion_trigger > button").forEach((btn) => {
        if (btn !== this) {
          btn.classList.remove("active");
          const otherContent = btn.nextElementSibling;
          otherContent.classList.remove("open_accordion");
          otherContent.style.maxHeight = null;
          otherContent.style.paddingTop = "0";
          otherContent.style.paddingBottom = "0";
          btn.querySelector(".icon-plus").style.display = "inline";
          btn.querySelector(".icon-minus").style.display = "none";
        }
      });

      if (isActive) {
        // Close the current accordion if it's active
        this.classList.remove("active");
        content.classList.remove("open_accordion");
        content.style.maxHeight = null;
        content.style.paddingTop = "0";
        content.style.paddingBottom = "0";
        this.querySelector(".icon-plus").style.display = "inline";
        this.querySelector(".icon-minus").style.display = "none";
      } else {
        // Open the clicked accordion
        this.classList.add("active");
        content.classList.add("open_accordion");
        content.style.paddingTop = "5px";
        content.style.paddingBottom = "10px";
        content.style.maxHeight = content.scrollHeight + 20 + "px";
        this.querySelector(".icon-plus").style.display = "none";
        this.querySelector(".icon-minus").style.display = "inline";
      }
    });
  });
});

$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('.omnisend-reset-64516494e54adad5ac574ba4.omnisend-form-64516494e54adad5ac574ba4-container').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Customer Email Laoding");
$('.omnisend-reset-64516494e54adad5ac574ba4.omnisend-form-64516494e54adad5ac574ba4-container').attr('aria-label', 'Get 20% off promotional-form');
$('.omnisend-form-64516494e54adad5ac574ba4-content-inner img').removeAttr('aria-hidden');
$('.omnisend-form-64516494e54adad5ac574ba4-content-inner img.omnisend-form-64516494e54adad5ac574ba4-background-image').attr('alt','a woman wearing ettika jewelry and watering can on the flowers');
  }
}); 

$(document).ready(function() {
    $('.banner.banner--content-align-center.banner--content-align-mobile-center.banner--medium.banner--stacked.banner--mobile-bottom .banner__content.banner__content--middle-center.page-width .banner__buttons a').attr('aria-label', 'shop now our best seller collection');
    $("footer.footer .footer-block.grid__item .rte a").attr("aria-label","Learn More About us");
    $('.link--text.list-menu__item.list-menu__item--link[href="https://ettika.myreturnscenter.com/"]').attr('aria-label', 'Returns, You will be leave ettika.com and redirect to ettika.returnscenter.com');
    $('.link.link--text.list-menu__item.list-menu__item--link[href="https://www.shareasale.com/shareasale.cfm?merchantID=91592"]').attr("aria-label","Affiliate Program, You wll be leave ettika.com and redirect to shareasale.com");
    $(".rte.umr h5").attr("aria-level","3");
    $(".elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1").addClass("btm-text");
    $(".elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1.btm-text br").remove();
    $('.elm.text-edit.gf-elm-left.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf_gs-text-paragraph-1.gf-elm-center-lg.con-h1.btm-text p font').contents().filter(function(){
      return this.nodeType == 3 && $.trim(this.nodeValue).length;
  }).wrap('<p class="new" />');
  $(".elm.text-edit.gf-elm-center.gf-elm-center-md.gf-elm-center-sm.gf-elm-center-xs.gf-elm-center-lg.h-level-1 h2").attr("aria-level","1");
  $('.button.button--secondary[href="/collections/back-necklaces"]').attr("aria-label","Shop now,new: back necklace");
  });
class A {
  constructor(o) {
    this.element  = o;
    this.timezone = o.dataset.timezone || "UTC";
    const raw     = (o.dataset.endTime || "").trim();

    this.endTime = this.parseTimezoneDate(raw, this.timezone);

    this.daysElement    = o.querySelector(".dayss");
    this.hoursElement   = o.querySelector(".hourss");
    this.minutesElement = o.querySelector(".minutess");
    this.secondsElement = o.querySelector(".secondss");

    // If endTime invalid → hide just this timer
    if (!(this.endTime instanceof Date) || isNaN(this.endTime.getTime())) {
      console.error("Invalid endTime for countdown:", raw);
      this.element.classList.add("hide_timer");
      return;
    }

    // If already expired → hide just this timer
    if (Date.now() >= this.endTime.getTime()) {
      this.element.classList.add("hide_timer");
      return;
    }

    this.updateTimer = this.updateTimer.bind(this);
    this.start();
  }

  // Interpret "YYYY-MM-DD HH:mm[:ss]" as wall clock time in `tz`, return a UTC Date
  parseTimezoneDate(s, tz) {
    try {
      const m = String(s).match(
        /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/
      );
      if (!m) return null;
      const [_, Y, Mo, D, H, Mi, S = "0"] = m;
      const y = +Y, mo = +Mo, d = +D, h = +H, mi = +Mi, se = +S;

      // Start with a UTC guess using the local wall time parts
      const utcGuess = Date.UTC(y, mo - 1, d, h, mi, se);

      // What does that instant look like in `tz`?
      const fmt = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        hour12: false,
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit"
      });
      const parts = Object.fromEntries(
        fmt.formatToParts(new Date(utcGuess)).map(p => [p.type, p.value])
      );
      const tzAsUtc = Date.UTC(
        +parts.year, +parts.month - 1, +parts.day,
        +parts.hour, +parts.minute, +parts.second
      );

      // Offset (ms) of `tz` at that local time
      const offset = tzAsUtc - utcGuess; // e.g. -7h for PDT

      // Apply inverse offset to get the intended instant
      return new Date(utcGuess - offset);
    } catch (e) {
      console.error("Error parsing date:", e);
      return null;
    }
  }

  start() {
    this.updateTimer();                 // initial paint
    this.interval = setInterval(this.updateTimer, 1000);
  }

  updateTimer() {
    const remaining = this.endTime.getTime() - Date.now();

    if (remaining <= 0) {
      this.element.classList.add("hide_timer");
      clearInterval(this.interval);
      return;
    }

    const totalSec = Math.floor(remaining / 1000);
    const days     = Math.floor(totalSec / 86400);
    const hours    = Math.floor((totalSec % 86400) / 3600);
    const minutes  = Math.floor((totalSec % 3600) / 60);
    const seconds  = totalSec % 60;

    if (this.daysElement)    this.daysElement.textContent    = String(days).padStart(2, "0");
    if (this.hoursElement)   this.hoursElement.textContent   = String(hours).padStart(2, "0");
    if (this.minutesElement) this.minutesElement.textContent = String(minutes).padStart(2, "0");
    if (this.secondsElement) this.secondsElement.textContent = String(seconds).padStart(2, "0");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".countdown-timer").forEach((el) => new A(el));
});